export const WAREHOUSE_TASK = 'WarehouseTask';
export const WAREHOUSE_TASK_LINE = 'WarehouseTaskLine';
export const WarehouseTaskStatusValues = [
    'open',
    'assigned',
    'in-progress',
    'paused',
    'done',
    'cancelled',
];
export const WAREHOUSE_TASK_STATUS_LABELS = {
    open: 'Aberta',
    assigned: 'Atribuída',
    'in-progress': 'Em andamento',
    paused: 'Pausada',
    done: 'Concluída',
    cancelled: 'Cancelada',
};
export const WarehouseTaskLineStatusValues = [
    'pending',
    'in-progress',
    'done',
    'skipped',
    'cancelled',
];
export const WAREHOUSE_TASK_LINE_STATUS_LABELS = {
    pending: 'Pendente',
    'in-progress': 'Em andamento',
    done: 'Concluída',
    skipped: 'Adiada',
    cancelled: 'Cancelada',
};
//# sourceMappingURL=warehouse-task.js.map